import { useSiteInfo } from '../../SiteInfo/hooks/useSiteInfo';

const CUSTOM_ATTRIBUTE_IS_APPMODE = 'isAppMode';
const CUSTOM_ATTRIBUTE_IS_BOT_CALL = 'isBotCall';
const CUSTOM_ATTRIBUTE_IS_INTERNAL_CALL = 'isInternalCall';
const CUSTOM_ATTRIBUTE_IS_INFOLINE_CALL = 'isInfolineCall';

function trackNewRelicCustomAttribute(attribute: string, value: any) {
  if (typeof window !== 'undefined' && window.newrelic) {
    window.newrelic.setCustomAttribute(
      attribute,
      typeof value === 'boolean' ? value.toString() : value,
    );
  }
}

export function useNewRelicSiteAttributes() {
  const siteSettings = useSiteInfo().settings;

  trackNewRelicCustomAttribute(
    CUSTOM_ATTRIBUTE_IS_APPMODE,
    siteSettings.isAppMode,
  );
  trackNewRelicCustomAttribute(
    CUSTOM_ATTRIBUTE_IS_BOT_CALL,
    siteSettings.isBotCall,
  );
  trackNewRelicCustomAttribute(
    CUSTOM_ATTRIBUTE_IS_INTERNAL_CALL,
    siteSettings.isInternalCall,
  );
  trackNewRelicCustomAttribute(
    CUSTOM_ATTRIBUTE_IS_INFOLINE_CALL,
    siteSettings.isInfolineCall,
  );
}
